import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ErrorBoundary from './components/ErrorBoundary';
import GoogleTagManager from './components/GoogleAnalytics';
import GlobalStyles from './styles/GlobalStyles';
import FullMenu from './pages/FullMenu';
import LunchMenu from './pages/LunchMenu';
import AppetizerMenu from './pages/AppetizerMenu';
import PrintableMenu from './pages/PrintableMenu';
import PrintableLunchMenu from './pages/PrintableLunchMenu';
import PrintableAppetizerMenu from './pages/PrintableAppetizerMenu';
import PrintableCustomMenu from './pages/PrintableCustomMenu';
import { GTM_CONFIG } from './config/analytics';

const AppContainer = styled.div`
  min-height: 100vh;
`;

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <AppContainer>
          <GlobalStyles />
          <GoogleTagManager containerId={GTM_CONFIG.CONTAINER_ID} />
          <Routes>
            <Route path="/" element={
              <>
                <Header />
                <Hero />
                <About />
                <Menu />
                <Contact />
                <Footer />
                <FloatingButtons />
              </>
            } />
            <Route path="/full-menu" element={<FullMenu />} />
            <Route path="/lunch-menu" element={<LunchMenu />} />
            <Route path="/appetizer-menu" element={<AppetizerMenu />} />
            <Route path="/printable-menu" element={<PrintableMenu />} />
            <Route path="/printable-lunch" element={<PrintableLunchMenu />} />
            <Route path="/printable-appetizer" element={<PrintableAppetizerMenu />} />
            <Route path="/printable-custom" element={<PrintableCustomMenu />} />
          </Routes>
        </AppContainer>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
